import {INIT_APP} from '~/common/fabric/constants';
import {SET_EVITE_EVENT, UPDATE_EVITE_EVENT} from './constants';

/*
  The eviteEvent reducer holds the 'event' model as returned by the server.
  It should NEVER be modified.
  Data only replaced when we receive a new EventModel from the server.
  Intended for use by api calls.
*/

const initialState = {
  // Initially empty
  // will be set to the contents of the event model returned by the server
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_EVITE_EVENT:
      return {...action.payload};
    case INIT_APP:
      return {...action.payload.event};
    case UPDATE_EVITE_EVENT:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
